import { base } from '@/app/editor/sidebar/constant';
import { AtomServiceExportData } from '@/app/editor/iframe/atom/atom-service/export/AtomServiceExportData';
import HELPER from '@/app/utils/HELPER';
import { Atom } from '@/app/editor/iframe/atom/Atom';
import type { TypeExportData } from '@/app/editor/iframe/atom/Atom.model';
import type { AtomModel, FormControlSetting, Font } from '@/app/editor/iframe/atom/Atom.model';
import { DataManager } from '@/app/editor/iframe/atom/service/DataManager';
/**
 * GpElementExportService
 */
export class GpElementExportService extends AtomServiceExportData {
  /**
   * formatDataAtomInExport
   * @override AtomServiceExportData.formatDataAtomInExport
   * @param data data export
   * @returns new data export
   */
  formatDataAtomInExport(data: TypeExportData): TypeExportData {
    const $buttonClone = this.atom.$el.clone();
    const $html = jQuery('<div />').append($buttonClone);
    let html = $html.html();
    html = HELPER.clearExportedData(html);
    html = HELPER.compressHTML(html);
    html = HELPER.simpleHTMLEntities(html);
    data.html = html;
    return data;
  }
}
import { ElementRender } from '@/app/editor/iframe/atom/atom-service/render/ElementRender';

/**
 * Button Atom Element
 */
export class GpElement extends Atom {
  public $el: JQuery;
  public atom: Atom;

  /**
   * Thông tin riêng của Atom
   * @returns object watch
   */
  getDataAtom(): AtomModel {
    const data: AtomModel = {
      type: this.getType(),
      id: this.getId(),
      nodeId: this.getIdNode(),
      name: this.getLabel(),
      slug: this.getSlug(),
      groupName: this.getGroupName(),
      settings: this.getSettings(),
      formControlSettings: this.getFormControlSettings(), // read style setting
      data: { items: [] },
      html: this.getTemplate(),
      class: this.getTargetClassSelector(),
      style: this.getStyle(),
      script: this.getScript(),
      libs: this.getLibs(),
      fonts: [] as Array<Font>,
      version: 1,
    };
    return data;
  }

  /**
   * @override initAtomRender
   */
  initAtomRender() {
    this.atomRender = new ElementRender(this);
    const settings = this.getDataAtom().settings;
    DataManager.setState('setting', { changed: false }, this.getId());
    if (settings) {
      DataManager.setState(
        'setting',
        {
          changed: true,
          data: settings,
          tab: 'Settings',
          drag: false,
          capture: undefined,
          forceOpen: true,
        },
        this.getDataAtom().id,
      );
      DataManager.getInstance().notify();
    }
  }

  /**
   * setTemplate update template when editcode with context menu
   * @param template string
   */
  setTemplate(template: string): void {
    const $template = jQuery('<div />').html(this.getDataBkSettingByKey(base._template));
    template = template.replace(/script/g, 'scri-pt');
    // set live
    this.$el.find('.elm').html(template);
    const $templateBk = jQuery('<div>' + $template.html() + '</div>');
    $templateBk.find('.elm').html(template);

    $template.html($templateBk.html());
    this.data.atom.html = template;
    this.render();
    return;
  }

  /**
   * get Data from html attr
   * @returns Group Name
   */
  getGroupName(): string {
    return this.$el.attr('data-groupname') || 'Element';
  }
  /**
   * getClassName
   * @returns selector with Class name of element
   */
  getTargetClassSelector(): string {
    return '';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page replace writeStyle, readStyle
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return [];
  }

  /**
   * @override Atom.initAtomExport
   */
  initAtomExport() {
    this.atomServiceExportData = new GpElementExportService(this);
  }
}
